// --- DEPRECATED ENTITY CONFIG SYSTEM ---
// This file is being phased out in favor of co-located feature architecture.
// See CLAUDE.md section 13 for details.

import { EntityConfigItem } from "./types";

// --- MAIN ENTITY CONFIG ---
// Keeping minimal structure while migration completes
export const entityConfig: Record<string, EntityConfigItem<any>> = {};

// --- Core Type Exports ---
export type TargetEntityType = string;
